import { render, staticRenderFns } from "./CommercialPolicyPayment.vue?vue&type=template&id=5d76bcc9&scoped=true&"
import script from "./CommercialPolicyPayment.vue?vue&type=script&lang=js&"
export * from "./CommercialPolicyPayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d76bcc9",
  null
  
)

export default component.exports